import Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import { EVENT_NAMES } from '../constants';
import type { StaffMembershipType } from '../types';
import { reset, load as staffMembershipsLoad } from './core';

/**
 * Initialize the page with expected data.
 */
export const load = (
  /** Provided by fluxible. */
  actionContext: ActionContext,
  /**
   * Id and type of entity from which to load memberships.
   * Optional sessionId for courses.
   */
  {
    fromId,
    partnerId,
    sessionId,
    type,
    // API DI.
    _load = staffMembershipsLoad,
  }: {
    fromId: string | number;
    partnerId?: number | string;
    sessionId?: number | string;
    type: keyof typeof StaffMembershipType;
    _load?(actionContext: ActionContext, args: $TSFixMe): Q.Promise<void>;
  }
): Q.Promise<void> => {
  // Assumed called one time on page load. Do not re-call if data is initialized.
  const initializing = actionContext.getStore('StaffManagementStoreV2').data('initializing');
  if (initializing) {
    if (type !== 'partner' && !partnerId) {
      return Q.reject(new Error('partnerId required if type !== partner.'));
    }
    // Component is not built to swap between different entities.
    actionContext.dispatch(EVENT_NAMES.UPDATE, { fromId, partnerId: partnerId || fromId, type });
    return actionContext.executeAction(_load, { fromId, sessionId, type }).catch(() => {
      // The UI calling this will observe the error stored in state and degrade gracefully.
      // Any other logging is assumed done at a lower level.
    });
  } else {
    return Q.resolve();
  }
};

export const unload = (
  /** Provided by fluxible. */
  actionContext: ActionContext,
  {
    // API DI.
    _reset = reset,
  }: {
    _reset?(actionContext: ActionContext, args: $TSFixMe): void;
  } = {}
): Q.Promise<void> => {
  actionContext.executeAction(_reset);
  return Q.resolve();
};
